import type { MeasureType } from '@/domain/model/measures'

import {
  getCurrentQuestionById,
  GetCurrentQuestionByIdProps,
} from './getCurrentQuestionById'

export const calculateAverage = (data?: MeasureType[]) => {
  if (!data?.length) return 0
  let sum = 0
  for (const num of data) {
    sum += Number(num.answer_value)
  }
  const average = sum / data.length
  return average.toFixed(1)
}

export const getCalculateMeasuresByQuestionId = ({
  data,
  questionId,
}: GetCurrentQuestionByIdProps) => {
  if (!data || !questionId) {
    return {
      latestScore: 0,
      average: 0,
      totalAssessments: 0,
    }
  }
  const getQuestionById = getCurrentQuestionById({
    data,
    questionId,
  })

  const sortedMeasures =
    getQuestionById?.measures?.sort((a, b) => {
      const dateA = new Date(a.answer_date).getTime()
      const dateB = new Date(b.answer_date).getTime()
      return dateB - dateA
    }) || []

  const latestScore = sortedMeasures.length
    ? Number(sortedMeasures[0]?.answer_value)
    : 0

  return {
    latestScore,
    average: calculateAverage(getQuestionById?.measures),
    totalAssessments: getQuestionById?.measures.length,
  }
}
